import React from 'react';
import { Popup, Icon } from 'semantic-ui-react';
import ThemeSelector from '../../themes/theme-selector';

const theme = ThemeSelector.theme();
const IS_WHITE_LABEL = ThemeSelector.isWhiteLabel();
const PLATFORM_NAME = IS_WHITE_LABEL ? theme.platformName : 'dyzio';

const PrivateDataComponent = () => (
  <Popup
    trigger={<Icon name="lock" color="orange" />}
    content={`This is private data. The influencer must log in and authorise ${PLATFORM_NAME} to fetch it for you.`}
  />
);

export default PrivateDataComponent;



/** WEBPACK FOOTER **
 ** ./src/components/private-data-component/index.js
 **/